export enum MultiParticipantDetailsDataHook {
  PARTICIPANTS_COUNT = 'multi-participant-details-count',
}
